import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';

const el = document.querySelector('#pricing-calculator');
if (el) {
	const root = ReactDOM.createRoot(el);
	root.render(
		<StrictMode>
			<App dataURL={el.getAttribute('data-rest-url')} />
		</StrictMode>,
	);
}
